import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AccountVerified = () => {
    const [countdown, setCountdown] = useState(4);
    const navigate = useNavigate();
    const isAuth = useSelector(state => state.users.auth);

    useEffect(() => {
        if (countdown === 0) {
            navigate(isAuth ? '/dashboard' : '/account/login');
            return;
        }
        const timer = setTimeout(() => setCountdown(c => c - 1), 1000);
        return () => clearTimeout(timer);
    }, [countdown, navigate, isAuth]);

    return (
        <div className="not-verified-page">
            <div className="not-verified-card">
                <div className="not-verified-icon account-verified-icon">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                <h2 className="not-verified-title">Účet bol úspešne overený</h2>
                <p className="not-verified-text">
                    Váš účet je teraz aktívny. Môžete začať používať Envicloud naplno.
                </p>
                <p className="not-verified-hint">
                    Presmerovanie za <strong>{countdown}</strong> {countdown === 1 ? 'sekundu' : countdown < 5 ? 'sekundy' : 'sekúnd'}…
                </p>
            </div>
        </div>
    );
};

export default AccountVerified;
